import { defineComponent as _defineComponent } from 'vue'
import { useStore } from "@/store";
import { ActionTypes } from "@/store/action-types";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose }) {
  expose();

const photoInput = ref(null);
const store = useStore();

const photo = computed(() => store.state.photo);
const isLoading = computed(() => store.state.isLoading);

function accept() {
  store.dispatch(ActionTypes.ACCEPT);
}

function takePhoto() {
  (photoInput.value! as HTMLInputElement).click();
}

async function onPhotoTaken(event: Event) {
  const file = (event.target as HTMLInputElement).files![0];
  store.dispatch(ActionTypes.PROCCESS, file);
}

const __returned__ = { photoInput, store, photo, isLoading, accept, takePhoto, onPhotoTaken, get useStore() { return useStore }, get ActionTypes() { return ActionTypes }, computed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})